import type { Feature, FeatureModule } from '../../../../types';
import { featureList } from '../../../helpers';
import { DEVELOPMENT_LINK2PAY_FEATURE_GROUP } from './group';

export const DEVELOPMENT_LINK2PAY_FEATURES = {
  ACCESS: {
    guid: '0dc6cde0-5ed1-4307-89a4-05749fec0001',
    name: 'development:link2pay:access',
    description: 'Access the Link2Pay development tool',
    action: 'read',
    product: 'app',
    parentGuid: DEVELOPMENT_LINK2PAY_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { DEVELOPMENT_LINK2PAY_FEATURE_GROUP } from './group';

export const DEVELOPMENT_LINK2PAY_MODULE: FeatureModule = {
  product: 'app',
  groups: [DEVELOPMENT_LINK2PAY_FEATURE_GROUP],
  features: featureList(DEVELOPMENT_LINK2PAY_FEATURES),
};
